import { appScreen, Button, Panel, t, Image, Loading, preciseMinus, formatToCommaWithLang } from '@slot-nx/core'
import { gameConfig } from '../../config'
import { GrayBackground } from '../GrayBackground'
import { Assets, TextStyle } from 'pixi.js'
import { Container, Text } from '@pixi/react'
import { BetDetailTab, DetailGameType } from '../../domain/betDetail/enum/betDetailEnum'
import { useBetDetailStore } from '../../domain/betDetail/store/betDetailStore'
import { SwitchGameTypeTab } from './SwitchGameTypeTab'
import { betDetailService } from '../../domain/betDetail/service/BetDetailService'
import { ReelMultiplier, ReelTable } from './ReelTable'

import leftBtn_click from '../../../asset/images/betDetail/btn_left_click.png'
import leftBtn_hover from '../../../asset/images/betDetail/btn_left_hover.png'
import leftBtn_normal from '../../../asset/images/betDetail/btn_left_normal.png'
import leftBtn_unable from '../../../asset/images/betDetail/btn_left_unable.png'

import rightBtn_click from '../../../asset/images/betDetail/btn_right_click.png'
import rightBtn_hover from '../../../asset/images/betDetail/btn_right_hover.png'
import rightBtn_normal from '../../../asset/images/betDetail/btn_right_normal.png'
import rightBtn_unable from '../../../asset/images/betDetail/btn_right_unable.png'
import { PayoutDetailBox } from './PayoutDetailBox'
import { GodziTicket } from './GodziTicket'
import { GodziType } from '../../domain/godziDrop/enum/godziDropEnum'
import { CloseButton } from '../menu/CloseButton'

const titleTextStyle = new TextStyle({
  fontSize: 54,
  fontWeight: '600',
  fill: '#FFFFFF',
})

const yellowTextStyle = new TextStyle({
  fontSize: 42,
  fontWeight: 'bold',
  fill: '#F7E584',
})

Assets.addBundle('DetailPageControl', [
  { alias: 'leftBtn_click', src: leftBtn_click, loadParser: 'loadTextures' },
  { alias: 'leftBtn_hover', src: leftBtn_hover, loadParser: 'loadTextures' },
  { alias: 'leftBtn_normal', src: leftBtn_normal, loadParser: 'loadTextures' },
  { alias: 'leftBtn_unable', src: leftBtn_unable, loadParser: 'loadTextures' },
  { alias: 'rightBtn_click', src: rightBtn_click, loadParser: 'loadTextures' },
  { alias: 'rightBtn_hover', src: rightBtn_hover, loadParser: 'loadTextures' },
  { alias: 'rightBtn_normal', src: rightBtn_normal, loadParser: 'loadTextures' },
  { alias: 'rightBtn_unable', src: rightBtn_unable, loadParser: 'loadTextures' },
])

interface BetDetailProps {
  isFromOp?: boolean
}

export const BetDetail = (props: BetDetailProps) => {
  const [
    isOpenBetDetail,
    betDetailData,
    selectShowGameType,
    detailGameType,
    getCurrentTableSnapshot,
    hasPrev,
    hasNext,
  ] = useBetDetailStore(x => [
    x.isOpenBetDetail,
    x.betDetailData,
    x.selectShowGameType,
    x.detailGameType,
    x.getCurrentTableSnapshot,
    x.computed.hasPrev,
    x.computed.hasNext,
  ])
  const width = 1044
  const height = 1892
  const y = (appScreen.height - height) / 2
  if (!isOpenBetDetail) return false
  const godziType = betDetailData.gameDetail.godziBetDetail.type
  const isWinFreeGame = useBetDetailStore.getState().isGodziWinFreeGame()
  return (
    <GrayBackground name="BetDetailOverlay" width={gameConfig.resolution.width} height={gameConfig.resolution.height}>
      <Panel x={20} y={y} width={width} height={height} border={{ color: '#C1C1C1', width: 3 }} radius={15}>
        <Text text={t('betDetail_title')} x={width / 2} y={70} anchor={[0.5, 0.5]} style={titleTextStyle} />
        {props.isFromOp
          ? null
          : (
              <CloseButton
                x={appScreen.width - 120}
                y={15}
                width={70}
                height={70}
                onPress={() => {
                  betDetailService.resetDetailData()
                }}
              />
            )}
        {betDetailData.refNo !== ''
          ? (
              <Container>
                <Panel name="GameDetailBackGround" x={10} y={120} width={width - 20} height={1750} border={{ color: '#2A2A2C', width: 3 }} radius={5} backgroundColor="#2A2A2C" />
                <HistoryTab width={width} selectShowGameType={selectShowGameType} godziType={godziType} isWinFreeGame={isWinFreeGame} isVoucherBet={betDetailData.voucherStake > 0} />
                {selectShowGameType === BetDetailTab.Godzi && godziType === GodziType.FreeGame
                && (
                  <Panel
                    name="GodziFreeGameBackGround"
                    x={10}
                    y={195}
                    width={width - 20}
                    height={1690}
                    border={{ color: '#4E0802', width: 3 }}
                    radius={5}
                    backgroundColor="#4E0802"
                  />
                )}
                <SwitchGameTypeTab />

                <PayoutDetailBox y={1214} />

                <PayoutDetailBox y={1214} />

                {selectShowGameType === BetDetailTab.Godzi
                && (godziType === GodziType.RatioPrize || godziType === GodziType.FreeSpin)
                  ? (
                      <GodziTicket
                        width={width}
                        godziType={godziType}
                        payout={betDetailData.gameDetail.godziBetDetail.payout}
                        prize={betDetailData.gameDetail.godziBetDetail.prize}
                      />
                    )
                  : (
                      <>
                        <Image
                          name="tableBg"
                          image={detailGameType === DetailGameType.Free ? 'freeGameTable' : 'mainGametable'}
                          x={120}
                          y={520}
                          width={width - 240}
                          height={660}
                        />
                        <ReelTable
                          slotTable={getCurrentTableSnapshot().slotTable}
                          winningReels={getCurrentTableSnapshot().winningReels}
                          // width={width - 300}
                          // height={610}
                          x={150}
                          y={540}
                        />

                        <Button
                          name="PrevBtn"
                          x={38}
                          y={700}
                          width={55}
                          height={160}
                          onPress={() => {
                            betDetailService.selectPrevious()
                          }}
                          defaultView="leftBtn_normal"
                          hoverView="leftBtn_hover"
                          pressedView="leftBtn_click"
                          disabledView="leftBtn_unable"
                          enabled={hasPrev}
                        />

                        <Button
                          name="NextBtn"
                          x={952}
                          y={700}
                          width={55}
                          height={160}
                          onPress={() => {
                            betDetailService.selectNext()
                          // soundManager.play(SoundType.buttonConfirm)
                          }}
                          defaultView="rightBtn_normal"
                          hoverView="rightBtn_hover"
                          pressedView="rightBtn_click"
                          disabledView="rightBtn_unable"
                          enabled={hasNext}
                        />

                        <Image
                          name="MultiplierReelBackground"
                          image="muliplierBar"
                          width={width - 280}
                          height={160}
                          x={140}
                          y={385}
                          anchor={[0, 0]}
                        />
                        <Image
                          name="multiplierSelectBg"
                          image="multiplierSelectBg"
                          width={120}
                          height={120}
                          x={145}
                          y={395}
                          anchor={[0, 0]}
                        />
                        <Image
                          name="MultiplierSelectFrame"
                          image="multiplierSelectFrame"
                          width={145}
                          height={135}
                          x={135}
                          y={390}
                          anchor={[0, 0]}
                        />
                        <ReelMultiplier
                          snapshot={getCurrentTableSnapshot()}
                          x={205}
                          y={360}
                        />
                      </>
                    )}

                <Text text={`${t('betDetail_refNo')} ${betDetailData.refNo}`} x={width / 2} y={height - 250} anchor={[0.5, 0.5]} style={yellowTextStyle} />
                <HistoryFooter
                  width={width}
                  height={height}
                  voucherStake={betDetailData.voucherStake}
                  totalStake={selectShowGameType === BetDetailTab.Normal ? betDetailData.stake : betDetailData.gameDetail.godziBetDetail.stake}
                  totalWinLose={selectShowGameType === BetDetailTab.Normal ? preciseMinus(preciseMinus(betDetailData.payout, betDetailData.gameDetail.godziBetDetail.payout), betDetailData.stake) : betDetailData.gameDetail.godziBetDetail.payout}
                  totalPayout={selectShowGameType === BetDetailTab.Normal ? preciseMinus(betDetailData.payout, betDetailData.gameDetail.godziBetDetail.payout) : betDetailData.gameDetail.godziBetDetail.payout}
                />
              </Container>
            )
          : <Loading x={width / 2} y={height / 2} width={100} height={100} />}
      </Panel>
    </GrayBackground>
  )
}

interface HistoryTabProps {
  godziType: GodziType
  selectShowGameType: BetDetailTab
  width: number
  isWinFreeGame: boolean
  isVoucherBet: boolean
}
const HistoryTab = (props: HistoryTabProps) => {
  if (props.godziType === GodziType.None) {
    return (
      <Text
        text={props.isVoucherBet ? t('voucher_header_round_title') : t('betList_tab_game')}
        x={props.width / 2}
        y={170}
        anchor={[0.5, 0.5]}
        style={new TextStyle({
          fontSize: 55,
          fontWeight: '900',
          fill: '#FFFFFF',
        })}
      />
    )
  }
  return (
    <>
      <Button
        name="main game tab"
        x={10}
        y={120}
        width={gameConfig.resolution.width / 2 - 10}
        height={80}
        onPress={() => {
          useBetDetailStore.setState({
            currentIndex: 0,
            selectShowGameType: BetDetailTab.Normal,
            detailGameType: DetailGameType.Main,
            tableSnapshots: useBetDetailStore.getState().betDetailData.gameDetail.snapShots,
          })
        }}
        defaultView="mainTabNormal"
        hoverView="mainTabHover"
        disabledView="tabUnselectedCorner"
        enabled={true}
      />
      <Text text={t('betList_tab_game')} x={props.width / 4} y={160} anchor={[0.5, 0.5]} style={new TextStyle({ fontSize: 42, fontWeight: '500', fill: '#FFFFFF' })} />

      <Button
        name="godzi game tab"
        x={props.width / 2}
        y={120}
        width={props.width / 2 - 10}
        height={80}
        onPress={() => {
          useBetDetailStore.setState({
            currentIndex: props.isWinFreeGame ? 0 : -1,
            selectShowGameType: BetDetailTab.Godzi,
            detailGameType: props.isWinFreeGame ? DetailGameType.Main : DetailGameType.Prize,
            tableSnapshots: props.isWinFreeGame
              ? useBetDetailStore.getState().betDetailData.gameDetail.godziBetDetail.snapShots
              : [],
          })
        }}
        defaultView="godziTabNormal"
        hoverView="godziTabHover"
        disabledView="tabUnselectedCorner"
        enabled={true}
      />
      <Text text={t('betList_tab_godzi')} x={props.width / 2 + props.width / 4} y={160} anchor={[0.5, 0.5]} style={new TextStyle({ fontSize: 42, fontWeight: '500', fill: '#F5E781' })} />
    </>
  )
}

interface HistoryFooterProps {
  width: number
  height: number
  totalStake: number
  totalWinLose: number
  totalPayout: number
  voucherStake: number
}
const HistoryFooter = (props: HistoryFooterProps) => {
  const footerWidth = props.width / 3 - 30

  const historyFooter = [
    { text1: t('betList_total_stake'), text2: props.totalStake },
    { text1: t('betDetail_total_winLose'), text2: props.totalWinLose },
    { text1: t('betDetail_total_payout'), text2: props.totalPayout },
  ]
  return (
    historyFooter.map((item, index) => {
      const isTotalStake = index === 0
      let displayNumStr = formatToCommaWithLang(item.text2)
      if (isTotalStake && props.voucherStake > 0) {
        displayNumStr = `0 (${formatToCommaWithLang(props.voucherStake)})`
      }
      return (
        <Panel
          key={index}
          x={25 + index * (footerWidth + 20)}
          y={props.height - 190}
          width={footerWidth}
          height={158}
          border={{
            color: '#C1C1C1',
            width: 2.5,
          }}
          radius={15}
          backgroundColor="#000000"
        >
          <Text
            text={item.text1}
            x={(footerWidth) / 2}
            y={40}
            anchor={[0.5, 0.5]}
            style={new TextStyle({
              fontSize: 36,
              fontWeight: 'normal',
              fill: '#828282',
            })}
          />
          <Text
            text={displayNumStr}
            x={(footerWidth) / 2}
            y={158 - 45}
            anchor={[0.5, 0.5]}
            style={new TextStyle({
              fontSize: 38,
              fontWeight: 'normal',
              fill: '#FFFFFF',
            })}
          />
        </Panel>
      )
    })
  )
}
